<template>
  <div>
    <div class="card card-box mb-3">
      <div class="card-body p-4">
        <h5>Odontogram</h5>
        <b-row class="mt-5">
          <b-col lg="12" md="12" class="text-center">
            <b-img v-bind:src="drawPath"></b-img>
          </b-col>
          <b-col lg="12" md="12">
            <label for="kondisi-gigi" class="font-weight-bold">Catatan:</label>
            <div v-html="checkValueData(dataRM.odontogram.notes) ? dataRM.odontogram.notes : '-'"></div>
          </b-col>
        </b-row>

        <div class="row mt-4">
          <div class="col-md-12 media">
            <div class="media-body">
              <label for="kondisi-gigi" class="font-weight-bold">Kondisi Gigi</label>
            </div>
          </div>
          <div class="col-md-12 table-responsive mt-3">
            <b-table
              :fixed="true"
              :items="listConditionGigi"
              :fields="fieldListGigi"
              :borderless="true"
              class="custom_border"
            >
              <template v-slot:cell()="data">
                <p v-if="data.item.is_blank">&nbsp;</p>
                <p v-else>{{ checkValueData(data.value) ? data.value : '-' }}</p>
              </template>
              <template v-slot:cell(icdx)="data">
                <p v-for="(v, i) in data.item.icdx" :key="i">{{ checkValueData(v) ? v : '-' }}</p>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <div class="card card-box mb-3">
      <div class="card-body p-4">
        <div class="row">
          <div class="col-md-5">
            <div class="row mb-4">
              <div class="col-md-6 font-weight-bold">Occlusi</div>
              <div class="col-md-6">{{ dataRM.odontogram.occlusi || '-' }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-6 font-weight-bold">Torus Palatinus</div>
              <div class="col-md-6">{{ dataRM.odontogram.torus_palatinus || '-' }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-6 font-weight-bold">Torus Mandibularis</div>
              <div class="col-md-6">{{ dataRM.odontogram.torus_mandibularis || '-' }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-6 font-weight-bold">Palatum</div>
              <div class="col-md-6">{{ dataRM.odontogram.palatum || '-' }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-6 font-weight-bold">Diastema</div>
              <div class="col-md-6">{{ convertData(dataRM.odontogram.diastema, dataRM.odontogram.ket_diastema, ',') }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-6 font-weight-bold">Jumlah photo yang diambil</div>
              <div class="col-md-6">{{ convertData(dataRM.odontogram.qty_photo, dataRM.odontogram.satuan_photo) }}</div>
            </div>
          </div>
          <div class="col-md-7">
            <div class="row mb-4">
              <div class="col-md-5 font-weight-bold">Gigi Anomali</div>
              <div class="col-md-7">{{ convertData(dataRM.odontogram.gigi_anomali, dataRM.odontogram.ket_gigi_anomali, ',') }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-5 font-weight-bold">Lain - Lain</div>
              <div class="col-md-7">{{ dataRM.odontogram.lain_lain || '-' }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-5 font-weight-bold">Decay</div>
              <div class="col-md-7">{{ dataRM.odontogram.d || '-' }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-5 font-weight-bold">Missing</div>
              <div class="col-md-7">{{ dataRM.odontogram.m || '-' }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-5 font-weight-bold">Filling</div>
              <div class="col-md-7">{{ dataRM.odontogram.f || '-' }}</div>
            </div>
            <div class="row mb-4">
              <div class="col-md-5 font-weight-bold">Jumlah rontgen photo yang diambil</div>
              <div class="col-md-7">{{ convertData(dataRM.odontogram.qty_rontgen, dataRM.odontogram.satuan_rontgen) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import rekamMedisMixin from "../mixins";
  
  export default {
    name: 'Odontogram',
    mixins: [rekamMedisMixin],
    props: ['dataRM'],
    data() {
      return {
        drawPath: null,
        listConditionGigi: [
          {
            id: null,
            no_gigi: null,
            bagian: null,
            kondisi: null,
            icd_x: [],
            keterangan: null,
            is_blank: true,
          }
        ],
        permukaanGigi: [
          { value: 'all', label: 'Semua' },
          { value: 'M', label: 'M - Messial' },
          { value: 'O', label: 'O - Occlusal' },
          { value: 'D', label: 'D - Distal' },
          { value: 'V', label: 'V - Vestibular/Bukal/Labial' },
          { value: 'L', label: 'L - Lingual/Palatal' },
        ],
      }
    },
    computed: {
      ...mapGetters(['getKlinikId']),
      fieldListGigi() {
        return (
          [
            {
              key: 'no_gigi',
              label: 'no gigi',
              thClass: 'head-custom',
              stickyColumn: true,
              isRowHeader: true,
            },
            {
              key: 'bagian',
              label: 'bagian',
              thClass: 'head-custom',
            },
            {
              key: 'kondisi',
              label: 'kondisi',
              thClass: 'head-custom',
            },
            {
              key: 'icdx',
              label: 'icd 10',
              thClass: 'head-custom',
            },
            {
              key: 'keterangan',
              label: 'keterangan tambahan',
              thClass: 'head-custom',
            },
          ]
        )
      },
    },
    mounted() {
      this.buildData();
    },
    watch: {
      dataRM(val) {
        this.buildData();
      }
    },
    methods: {
      convertData(val, ket, coma = '') {
        let result = '';
        if (this.checkValueData(val)) {
          result += val;
          if (this.checkValueData(ket)) result += `${coma} ${ket}`;
        } else {
          result = '-';
        }
        return result;
      },
      buildData() {
        if (this.checkValueData(this.dataRM.odontogram) && this.checkValueData(this.dataRM.odontogram.draw_path)) this.drawPath = this.dataRM.odontogram.draw_path;
        else this.drawPath = 'https://fs.izidok.id/izidok/odontogram/odontogram-20240313120342-115619585.png';

        if (this.dataRM.odontogram_table) {
          this.listConditionGigi = this.dataRM.odontogram_table.map(d => {
            let pg = this.permukaanGigi.find(pg => pg.value == d.permukaan_gigi);
            return {
              ...d,
              bagian: pg ? pg.label : '-',
              kondisi: this.setKondisi(d),
              icdx: d.icd_x.length > 0 ? d.icd_x.map(icd => `${icd.kode} - ${icd.description}`): '-',
              is_blank: false,
            }
          });
        }
      },
      setKondisi(data) {
        let kondisi = [];
        if (data.keadaan_gigi.length > 0) kondisi = [...kondisi, ...data.keadaan_gigi];
        if (data.bahan_restorasi.length > 0) kondisi = [...kondisi, ...data.bahan_restorasi];
        if (data.restorasi.length > 0) kondisi = [...kondisi, ...data.restorasi];
        if (data.protesa.length > 0) kondisi = [...kondisi, ...data.protesa];
        return kondisi.length > 0 ? kondisi.join(' - ') : '-';
      },
    }
  }
</script>

<style>
  .mb-header {
    margin-bottom: -15px;
  }
  .custom_border {
    border: 2px solid #eee;
    border-radius: 5px;
  }
  .custom_border td, .custom_border th {
    vertical-align: top;
  }
</style>